<template>
  <his-layout
    class="hisdata-fcbr100s1"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <template #search>
      <el-form :inline="true" :model="model" :rules="rules" ref="form">
        <el-form-item label="选择时间:" prop="date">
          <el-date-picker
            prop="date"
            v-model="model.date"
            type="datetimerange"
            value-format="timestamp"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData" :loading="loading">查询</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template #l-t-title>
      <span>{{ top.title }}</span>
    </template>
    <template #l-t-content>
      <v-chart :options="top.chart" :autoresize="true" />
    </template>
    <template #l-b-title>
      <span>{{ bottom.title }}</span>
    </template>
    <template #l-b-content>
      <v-chart :options="bottom.chart" :autoresize="true" />
    </template>
    <template #r-title>
      <span>{{ right.title }}</span>
    </template>
    <template #r-content>
      <el-table v-if="!loading" :data="curPageData" height="calc(100% - 120px)">
        <el-table-column
          v-for="(item, index) in right.thead"
          header-align="center"
          align="center"
          :key="item.prop"
          :label="item.label"
          :prop="item.prop"
          :fixed="index === 0"
          :width="index === 0 ? 160 : 120"
        ></el-table-column>
      </el-table>
      <el-pagination
        v-if="data.length > 0 && !loading"
        background
        :current-page.sync="paginationCfg.offset"
        :page-sizes="paginationCfg.limits"
        :page-size.sync="paginationCfg.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paginationCfg.total"
      ></el-pagination>
    </template>
  </his-layout>
</template>

<script>
import HisLayout from '../component/his-layout.vue';

import { makeLineCharts } from './utils';
import { queryOrdata } from '@/api/stat';

export default {
  components: {
    HisLayout
  },
  props: {
    sn: String,
    deviceType: String
  },
  data() {
    const data = [];
    return {
      data,
      loading: false,
      rules: {
        date: [{ required: true, message: '请选择日期', trigger: 'change' }]
      },
      bottom: {
        title: '负模式浓度',
        chart: makeLineCharts({
          color: '#f16aec',
          prop: 'cwaSccell2r',
          title: '负模式浓度',
          data: data
        })
      },
      top: {
        title: '正模式浓度',
        chart: makeLineCharts({
          color: '#7b6af1',
          prop: 'cwaSccell1r',
          title: '正模式浓度',
          data: data
        })
      },
      right: {
        title: '历史数据列表',
        thead: []
      },
      model: {
        date: [Date.now() - 36e5, Date.now()]
      },
      paginationCfg: {
        offset: 1,
        limit: 10,
        limits: [10, 50, 100, 200],
        total: 0
      }
    };
  },
  computed: {
    curPageData() {
      // 本地分页
      const { offset, limit } = this.paginationCfg;
      const realOffset = (offset - 1) * limit;
      return this.data.slice(realOffset, realOffset + limit);
    }
  },
  methods: {
    getData() {
      this.loading = true;
      const { offset, limit } = this.paginationCfg;
      queryOrdata({
        sn: this.sn,
        beginTime: this.model.date[0],
        endTime: this.model.date[1],
        busiType: '2',
        dataScale: 1,
        offset,
        limit
      })
        .then(res => {
          this.data.splice(0, Infinity, ...res.data.pageData);
          this.right.thead = res.data.dimensions.map((key, index) => ({
            label: res.data.dimensionsZh[index],
            prop: key
          }));
          // this.theadZh = res.data.dimensionsZh;
          // this.theadEn = res.data.dimensions;
          this.paginationCfg.total = res.data.pageData.length;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss">
.hisdata-fcbr100s1 {
  .el-pagination {
    margin-top: 14px;
    text-align: center;
  }
}
</style>
